var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCouponFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 4.5V1a1 1 0 00-1-1h-12a1 1 0 00-1 1v3.5a1.5 1.5 0 010 3V11a1 1 0 001 1h12a1 1 0 001-1V7.5a1.5 1.5 0 010-3zM6 7H5V5h1v2zm0-3H5V2h1v2zm0 6H5V8h1v2z",
    fill: "#1D54A7"
  })));
}

export default SvgIconCouponFilled;